import React from "react";
import styled from "styled-components";
import { useAtom } from "jotai";
import MoleculeAccountForm from "./MoleculeAccountForm";
import { palette } from "../../../../assets/styles/Palette";
import { H4 } from "../../../../assets/styles/Typography";
// import images from "../../../../assets/styles/Images";

const MoleculeAccount = ({ onOpenPopup = () => {} }) => {
  // 성공 팝업 오픈은 폼 내부에서 직접 onOpenPopup을 호출하여 동작하도록 유지합니다.

  return (
    <AccountContainer>
      {/* <SectionHeader>
        <H4 color="gray800">비밀번호 변경</H4>
      </SectionHeader> */}

      <MoleculeAccountForm onOpenPopup={onOpenPopup} /> {/* 팝업 열기 함수 전달 */}
    </AccountContainer>
  );
};

export default MoleculeAccount;


// CSS-in-JS 스타일링
const AccountContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const SectionHeader = styled.div`
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${palette.outlineGray};
`;
